export class ActiveTherapistModel {
  public therapistId?: number;
  public firstName?: string;
  public lastName?: string;
  public profileLargeURL?: string;
  public therapistStatusId?: number;
  public availableStatus?: string;
  public waitingForThisTherapist?: number;
  public acceptBookings?: boolean;
  public startTime?: string;
  public endTime?: string;
}
